module.exports = __webpack_public_path__ + "static/media/Tecnologia-Innovadora.99ce0553.svg";